import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Sayfa Bulunamadı" />
      <section className="min-h-[70vh] flex items-center">
        <div className="wb-container text-center">
          <div className="font-serif text-7xl md:text-9xl text-[#d4af37]">404</div>
          <h1 className="wb-h2 mt-6">Sayfa bulunamadı</h1>
          <p className="text-sm text-[#a0aabf] mt-3">Aradığınız sayfa silinmiş veya taşınmış olabilir.</p>
          <Link to="/" className="wb-btn-primary mt-8 inline-flex">Anasayfaya Dön</Link>
        </div>
      </section>
    </>
  );
}
